import { __assign } from 'tslib';
import React, { forwardRef, useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import { getDataTestId } from '../../shared/esm';

var styles = {"component":"navigation-bar__component_4pujg","sticky":"navigation-bar__sticky_4pujg","border":"navigation-bar__border_4pujg","mainLine":"navigation-bar__mainLine_4pujg","left":"navigation-bar__left_4pujg","center":"navigation-bar__center_4pujg","children":"navigation-bar__children_4pujg","content":"navigation-bar__content_4pujg","title":"navigation-bar__title_4pujg","subtitle":"navigation-bar__subtitle_4pujg","addons":"navigation-bar__addons_4pujg","rightAddons":"navigation-bar__rightAddons_4pujg"};
require('./index.css');

var NavigationBar = forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var _e = _a.align, align = _e === void 0 ? 'center' : _e, rightAddons = _a.rightAddons, leftAddons = _a.leftAddons, bottomAddons = _a.bottomAddons, sticky = _a.sticky, border = _a.border, subtitle = _a.subtitle, title = _a.title, children = _a.children, _f = _a.backgroundColor, backgroundColor = _f === void 0 ? 'var(--color-light-base-bg-primary)' : _f, contentWrapperClassName = _a.contentWrapperClassName, className = _a.className, contentClassName = _a.contentClassName, rightAddonsClassName = _a.rightAddonsClassName, leftAddonsClassName = _a.leftAddonsClassName, bottomAddonsClassName = _a.bottomAddonsClassName, dataTestId = _a.dataTestId;
    var _g = useState({ left: 0, right: 0 }), titleMargin = _g[0], setTitleMargin = _g[1];
    var leftAddonsRef = useRef(null);
    var rightAddonsRef = useRef(null);
    var hasLeftAddons = leftAddons && align !== 'left';
    // добавляет отступ для того чтобы title находился по центру не зависимо от ширины аддонов
    useEffect(function () {
        var _a, _b;
        var leftAddonsWidth = ((_a = leftAddonsRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
        var rightAddonsWidth = ((_b = rightAddonsRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
        var marginSize = Math.abs(rightAddonsWidth - leftAddonsWidth);
        var shouldAddLeftMargin = rightAddonsWidth - leftAddonsWidth > 0;
        setTitleMargin(function (prev) {
            var newState = shouldAddLeftMargin
                ? { left: marginSize, right: 0 }
                : { left: 0, right: marginSize };
            var isStateChanged = prev.left !== newState.left || prev.right !== newState.right;
            return isStateChanged ? newState : prev;
        });
    }, [hasLeftAddons, leftAddons, rightAddons]);
    return (React.createElement("div", { ref: ref, className: cn(styles.component, (_b = {},
            _b[styles.border] = border,
            _b[styles.sticky] = sticky,
            _b), className), style: __assign({}, (backgroundColor && { backgroundColor: backgroundColor })), "data-test-id": dataTestId },
        React.createElement("div", { className: cn(styles.mainLine, styles[align], contentClassName) },
            hasLeftAddons && (React.createElement("div", { className: cn(styles.addons, leftAddonsClassName), ref: leftAddonsRef }, leftAddons)),
            children && React.createElement("div", { className: styles.children }, children),
            title && (React.createElement("div", { className: cn(styles.content, contentWrapperClassName, (_c = {},
                    _c[styles[align]] = !hasLeftAddons,
                    _c)), style: __assign({}, (align === 'center'
                    ? {
                        marginLeft: titleMargin.left,
                        marginRight: titleMargin.right,
                    }
                    : null)) },
                React.createElement("div", { className: cn(styles.title, (_d = {},
                        _d[styles[align]] = !hasLeftAddons && !subtitle,
                        _d)), "data-test-id": getDataTestId(dataTestId, 'title') }, title),
                subtitle && (React.createElement("div", { className: styles.subtitle, "data-test-id": getDataTestId(dataTestId, 'subtitle') }, subtitle)))),
            rightAddons && (React.createElement("div", { className: cn(styles.rightAddons, styles.addons, rightAddonsClassName), ref: rightAddonsRef }, rightAddons))),
        bottomAddons && React.createElement("div", { className: bottomAddonsClassName }, bottomAddons)));
});
NavigationBar.displayName = 'NavigationBar';

export { NavigationBar };
